module.exports = __webpack_public_path__ + "static/media/iphone_14_purple.52e4df4b.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/iphone/iphone_14_purple.jpeg
// module id = 2173
// module chunks = 0